import React, { useState, useRef, useEffect } from "react";
import CommonInputContainer from "./CommonInputContainer";
import { DateRange } from "react-date-range";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

function CommonDateRangeSelector({
  value,
  placeholder,
  onChange,
  label,
  error,
  onFocus,
  onBlur,
  className,
  minDate,
  maxDate,
}) {
  const [showCalendar, setShowCalendar] = useState(false);
  const dropdownRef = useRef(null);

  const [selectedRange, setSelectedRange] = useState({
    startDate: value?.startDate ? new Date(value.startDate) : null,
    endDate: value?.endDate ? new Date(value.endDate) : null,
    key: "selection",
  });

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const sameDay =
      moment(startDate).isSame(endDate, "day") ||
      moment(startDate).isAfter(endDate);

    setSelectedRange({
      startDate,
      endDate,
      key: "selection",
    });

    if (startDate && endDate && !sameDay) {
      onChange({ startDate, endDate });
      setShowCalendar(false);
    }
  };

  // Restart selection if both dates are selected and user reopens
  useEffect(() => {
    if (showCalendar) {
      setSelectedRange({
        startDate: null,
        endDate: null,
        key: "selection",
      });
    }
  }, [showCalendar]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedStartDate = value?.startDate
    ? moment(value.startDate).format("MMM DD, YYYY")
    : "";
  const formattedEndDate = value?.endDate
    ? moment(value.endDate).format("MMM DD, YYYY")
    : "";

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <CommonInputContainer
        label={label}
        error={error && !(value?.startDate && value?.endDate)}
        className={className}
      >
        <input
          type="text"
          value={
            value?.startDate && value?.endDate
              ? `${formattedStartDate} - ${formattedEndDate}`
              : ""
          }
          placeholder={placeholder || "Start Date - End Date"}
          onFocus={(e) => {
            setShowCalendar(true);
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            onBlur && onBlur(e);
          }}
          readOnly
          className={`w-full h-12 items-center px-4 border ${
            error && !(value?.startDate && value?.endDate)
              ? "border-red-600"
              : "border-[#DBDBDB]"
          } rounded-lg placeholder:text-[#A4B1C1] focus:outline-none cursor-pointer`}
        />
      </CommonInputContainer>

      {showCalendar && (
        <div className="absolute z-50 mt-2 bg-white rounded-lg shadow-lg">
          <DateRange
            ranges={[selectedRange]}
            onChange={handleSelect}
            showDateDisplay={false}
            minDate={minDate}
            maxDate={maxDate}
          />
        </div>
      )}
    </div>
  );
}

export default CommonDateRangeSelector;
